import { DataService } from './../../services/data.service';
import { AllQuestionModalComponent } from './../all-question-modal/all-question-modal.component';
import { QuestionCompleteModalComponent } from './../question-complete-modal/question-complete-modal.component';
import { ImageModalComponent } from './../image-modal/image-modal.component';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';
import { ShowMovieComponent } from '../show-movie/show-movie.component';


@Component({
  selector: 'app-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrls: ['./question-modal.component.scss']
})
export class QuestionModalComponent implements OnInit {


  correctAnswer = false;
  showQuestion = true;
  isvideo = false;
  upComingBadge = '';
  pointNeed = 0;

  questionDetails: any;

  selectedOption: any;

  questionParams = {
    sdg: '',
    country: '',
    subject: '',
    difficulty: '',
    offset: 0
  };
  unattendedQuestionsList = [];
  nextQuestion = '';
  prevQuestion = '';

  lstCountriesExpedition = [{ id: 0, name: 'All countries', flag: 'assets/images/world-question.svg' }];
  selectedCountryExpedition = 'All countries';
  selectedCountryImage = 'assets/images/world-question.svg';

  allSubjectExpedition = [{ id: 0, name: 'All subjects' }];
  selectedSubjectExpedition = 'All subjects';

  allSdgExpedition = [{ id: 0, name: 'All SDG’s', image: 'assets/images/Countries.svg' }];
  selectedSdgExpedition = 'All SDG’s';
  selectedSdgImage = 'assets/images/Countries.svg';

  alphaIndex = ['A', 'B', 'C', 'D', 'E'];
  questionId: any;
  startTime: number;
  questionStatus: any;
  correctOption: any;
  view = false;
  questionScore = 0;
  questionIndex: number;

  totalQuestionCount = 0;
  isAnswerClicked = false;
  everAttented = false;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<QuestionModalComponent>,
    public router: Router,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data, public serviceData: DataService, public loaderService: LoaderService) {
      console.log(this.data);
     }

  ngOnInit(): void {
    this.view = this.data.view;
    console.log(this.view);
    this.questionParams = {
      sdg: this.data.sdg,
      country: this.data.country,
      subject: this.data.subject,
      difficulty: this.data.difficulty,
      offset: 0
    };
    console.log(this.data);
    // this.loaderService.display(true);
    this.serviceData.showMouseLoader();
    if (this.data.sdg != '0') {
      this.getSdg();
    } else if (this.data.country != '0') {
      this.getCountry();
    } else if (this.data.subject != '0') {
      this.getSubject();
    } else {
      this.getQuestionStatus();
    }
    // this.getCountry();
    // this.getSubject();


  }

  close() {
    // this.dialogRef.close();
    let data = {
      status: 'close',

    }
    if (!this.everAttented) {
      this.dialogRef.close('close');
    } else {
      this.dialogRef.close();
    }

  }

  answerClicked(item, option, questionId) {
    if (!this.isAnswerClicked) {
      this.isAnswerClicked = true;
      this.everAttented = true;

      // this.loaderService.display(true);
      this.serviceData.showMouseLoader();
      console.log(option);

      this.questionScore = 0;
      this.selectedOption = item;
      this.selectedOption.option = option;

      let data = {
        "selected_option": item.id,
        "duration": Math.floor((Date.now() - this.startTime) / 1000)
      }

      this.serviceData.markAnswer(this.questionId, data).subscribe((resp: any) => {
        console.log(resp);
        this.isAnswerClicked = false;
        if (resp.success) {
          this.showQuestion = false;
          if (item.id == this.questionDetails.correct_option) {
            this.correctAnswer = true;
            this.questionStatus.score = this.questionStatus.score + resp.data.score;
            this.questionScore = resp.data.score;
            this.questionStatus.answered_questions = this.questionStatus.answered_questions + 1;
          }
          else {
            this.questionStatus.answered_questions = this.questionStatus.answered_questions + 1;
            this.correctAnswer = false;
          }
          this.questionStatus.attempted_percentage = ((this.questionStatus.answered_questions / this.questionStatus.total_questions) * 100).toFixed(2);
          this.questionStatus.score_percentage = ((this.questionStatus.score / this.questionStatus.maximum_score) * 100).toFixed(2);
          console.log(this.questionStatus.attempted_percentage, this.questionStatus.score_percentage)
          if (this.questionStatus.score_percentage < 20) {
            this.questionStatus.badge = 'None';
            this.upComingBadge = 'Bronze';
            let x = Math.ceil(((20 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
            this.pointNeed = x;
          } else if (this.questionStatus.score_percentage >= 20 && this.questionStatus.score_percentage < 50) {
            this.questionStatus.badge = 'Bronze';
            this.upComingBadge = 'Silver';
            let x = Math.ceil(((50 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
            this.pointNeed = x;
          } else if (this.questionStatus.score_percentage >= 50 && this.questionStatus.score_percentage < 80) {
            this.questionStatus.badge = 'Silver';
            this.upComingBadge = 'Gold';
            let x = Math.ceil(((80 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
            this.pointNeed = x;
          } else {
            this.questionStatus.badge = 'Gold';
          }
          console.log(resp.data, 'de');
          if (this.unattendedQuestionsList.length > 1) {
            this.unattendedQuestionsList.every((qstn: any, index) => {
              if (qstn.id == questionId) {
                console.log(index, this.unattendedQuestionsList.length - 1)
                if (index == this.unattendedQuestionsList.length - 1) {
                  this.questionId = this.unattendedQuestionsList[0].id;
                  return false;
                } else {
                  this.questionId = this.unattendedQuestionsList[index + 1].id;
                  this.repopulateQuestionList(index);
                  return false;
                }
              } else {
                return true;
              }
            });
          }
          this.unattendedQuestionsList.forEach((qstn, index) => {
            if (qstn.id == questionId) {
              this.unattendedQuestionsList.splice(index, 1);
            }
          });
          console.log(this.unattendedQuestionsList);
        }
        // this.loaderService.display(false);
        this.serviceData.hideMouseLoader();
      }, Error => {
        // this.loaderService.display(false);
        this.serviceData.hideMouseLoader();
        console.log('Err is ', Error);
      });
    }
  }

  skipToNextQuestion() {
    console.log('skipped to next', this.questionId, this.unattendedQuestionsList);
    this.unattendedQuestionsList.every((qstn: any, index) => {
      if (qstn.id == this.questionId) {
        console.log(index, this.unattendedQuestionsList.length - 1)
        if (index == this.unattendedQuestionsList.length - 1) {
          console.log("last");
          this.getQuestionDetails(this.unattendedQuestionsList[0].id);
          return false;
        } else {
          this.getQuestionDetails(this.unattendedQuestionsList[index + 1].id);
          this.repopulateQuestionList(index);
          return false;
        }
      } else {
        return true;
      }
    });
  }
  
  continueNextQuestion() {
    this.questionDetails = null;
    // this.getQuestionDetails();
    console.log(this.unattendedQuestionsList);
    if (this.unattendedQuestionsList.length == 0) {
      // this.dialogRef.close("completed");
      if (this.data.difficulty != '') {
        this.dialogRef.close();
      } else {
        this.dialogRef.close("completed");
      }

    } else {
      this.correctAnswer = false;
      this.showQuestion = true;

      console.log('continue to next');
      this.getQuestionDetails(this.questionId);
    }
  }

  viewImage(image) {
    const dialogRef = this.dialog.open(ImageModalComponent, {
      disableClose: true,
      // width: '978px',
      width: 'auto',
      height: 'auto',
      maxWidth: '90vh',
      // maxHeight: '90vh',

      data: { 'image': image }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  viewAllQuestion() {
    this.dialogRef.close("next");
    // const dialogRef = this.dialog.open(AllQuestionModalComponent, {
    //   disableClose: true,
    //   width: '978px',
    //   height: 'auto',
    //   maxHeight: '90vh',

    //   // data: { 'question': movie }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   // console.log('The dialog was closed', result);
    // });
  }

  getQuestionStatus() {
    this.serviceData.getQuestionStatus(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data);
        this.questionStatus = resp.data;
        if (this.data.questionId) {
          this.getQuestionDetails(this.data.questionId);
        } else {
          this.getFirstQuestion();
        }
      }
    }, Error => {
      // this.loaderService.display(false);
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }

  getQuestionIndex(questionId) {
    if (this.unattendedQuestionsList.length == 0) {
      this.questionIndex = 1;
    } else {
      this.unattendedQuestionsList.forEach((qstn: any, index) => {
        if (qstn.id == questionId) {
          this.questionIndex = index + 1;
        }
      });
    }
  }

  getQuestionDetails(questionId) {
    // let temId = this.data.question.id
    // this.loaderService.display(true);
    this.serviceData.showMouseLoader();
    this.questionId = questionId;
    // this.getQuestionIndex();
    this.serviceData.getModalQuestion(questionId).subscribe((resp: any) => {
      if (resp.success) {
        this.questionDetails = null;
        this.getQuestionIndex(questionId);
        this.questionDetails = resp.data;
        this.questionDetails.options.forEach((qstn, index) => {
          if (qstn.id == this.questionDetails.correct_option) {
            this.correctOption = qstn;
            this.correctOption.option = this.alphaIndex[index];
          }
        });
        console.log(this.questionDetails, this.correctOption, 'de');
        this.startTime = Date.now();
        if (this.questionDetails.media_type == 3) {
          let vt = this.questionDetails.video_link.split('?');
          this.questionDetails.videoImage = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
        }
        // this.loaderService.display(false);
        this.serviceData.hideMouseLoader();

      }
    }, Error => {
      // this.loaderService.display(false);
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }

  // getFirstQuestion() {
  //   this.serviceData.getQuestionList(this.questionParams).subscribe((resp: any) => {
  //     if (resp.success) {
  //       let allQuestionList = resp.data.results;
  //       console.log(allQuestionList);
  //       allQuestionList.forEach(element => {
  //         if (!element.attempted) {
  //           this.unattendedQuestionsList.push(element);
  //         }
  //       });
  //       console.log(this.unattendedQuestionsList);
  //       this.getQuestionDetails(this.unattendedQuestionsList[0].id);
  //     }
  //   }, Error => {
  //     this.serviceData.hideMouseLoader();
  //     console.log('Err is ', Error);
  //   });

  // }

  getFirstQuestion() {
    this.serviceData.getUnansweredQuestionList(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp)
        this.unattendedQuestionsList.push(...resp.data.results);
        this.totalQuestionCount = resp.data.count;
        console.log(this.unattendedQuestionsList);
        // this.getQuestionDetails(this.unattendedQuestionsList[0].id);

        if (this.unattendedQuestionsList.length != 0) {
          this.getQuestionDetails(this.unattendedQuestionsList[0].id);
        } else {
          this.serviceData.hideMouseLoader();
          this.dialogRef.close("completed");
        }
      }
    }, Error => {
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }

  getSdg() {
    this.serviceData.getSDGlist().subscribe((resp: any) => {
      console.log(resp);
      if (resp.success) {
        this.allSdgExpedition.push(...resp.data.results);
        this.allSdgExpedition.forEach((element: any) => {
          if (element.id == (this.data.sdg || 0)) {
            this.selectedSdgExpedition = element.name;
            this.selectedSdgImage = element.image
          }
        });
        console.log(this.selectedSdgImage)
        if (this.data.country != '0') {
          this.getCountry();
        } else if (this.data.subject != '0') {
          this.getSubject();
        } else {
          this.getQuestionStatus();
        }
      }
    }, Error => {
      // this.loaderService.display(false);
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }
  getCountry() {
    this.serviceData.getCountriesMap().subscribe((resp: any) => {
      console.log(resp);
      if (resp.success) {
        this.lstCountriesExpedition.push(...resp.data.results);
        this.lstCountriesExpedition.forEach((element: any) => {
          if (element.id == (this.data.country || 0)) {
            this.selectedCountryExpedition = element.name;
            this.selectedCountryImage = element.flag;
          }
        });
        console.log(this.selectedCountryImage)
        if (this.data.subject != '0') {
          this.getSubject();
        } else {
          this.getQuestionStatus();
        }
      }
    }, Error => {
      // this.loaderService.display(false);
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }
  getSubject() {
    this.serviceData.getSubjectList().subscribe((resp: any) => {
      if (resp.success) {
        this.allSubjectExpedition.push(...resp.data.results);
        this.allSubjectExpedition.forEach(element => {
          if (element.id == (this.data.subject || 0)) {
            this.selectedSubjectExpedition = element.name;
          }
        });
        this.getQuestionStatus();
      }
    }, Error => {
      // this.loaderService.display(false);
      this.serviceData.hideMouseLoader();
      console.log('Err is ', Error);
    });
  }

  playVideo() {
    const dialogRef = this.dialog.open(ShowMovieComponent, {
      disableClose: true,
      width: '800px',
      height: 'auto',

      data: { 'movie': this.questionDetails.video_link, 'quizVideo': true }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  repopulateQuestionList(index) {
    if (this.unattendedQuestionsList.length - index == 3 && this.totalQuestionCount > this.unattendedQuestionsList.length) {
      // this.questionParams.offset = this.unattendedQuestionsList.length - 1;
      this.questionParams.offset = this.unattendedQuestionsList.length;
      this.serviceData.getUnansweredQuestionList(this.questionParams).subscribe((resp: any) => {
        if (resp.success) {
          this.unattendedQuestionsList.push(...resp.data.results);
          console.log(this.unattendedQuestionsList);
        }
      }, Error => {
        console.log('Err is ', Error);
      });
    }
  }

  ngOnDestroy() {
    this.serviceData.hideMouseLoader();
  }

}
